import script from "./RequestsActiveView.vue?vue&type=script&setup=true&lang=js"
export * from "./RequestsActiveView.vue?vue&type=script&setup=true&lang=js"

import "./RequestsActiveView.vue?vue&type=style&index=0&id=39f48d5e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-39f48d5e"]])

export default __exports__